import { createSlice } from '@reduxjs/toolkit';

import { updateCsatConfig } from '@polyai/stream/store/reducers/csat/actions';
import type {
  CSATConfig,
  CSATState,
} from '@polyai/stream/store/reducers/csat/types';
import { assignDefinedFields } from '@polyai/stream/store/utils/assign-fields';
import { assignMetadata } from '@polyai/stream/store/utils/assign-metadata';

const initialState = null as CSATState;

const slice = createSlice({
  name: 'csat',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateCsatConfig, (state, action) => {
      if (state === null) {
        // First time creating config
        const newConfig: CSATConfig = {
          enabled: action.payload.enabled ?? false,
          leadInMessage: action.payload.leadInMessage ?? '',
          surveyQuestion: action.payload.surveyQuestion ?? '',
          createdAt: '',
          createdBy: '',
          updatedAt: undefined,
          updatedBy: undefined,
        };
        assignMetadata(action, newConfig);
        return newConfig;
      }
      // Update existing config
      assignDefinedFields(state, action.payload);
      // Reset timestamps
      state.updatedAt = undefined;
      state.updatedBy = undefined;
      assignMetadata(action, state);
    });
  },
});

export { updateCsatConfig };

export * from './selectors';
export * from './types';
export default slice.reducer;
